import React, { useEffect, useState } from "react";
import style from "./proReportList.module.scss";
import Searchbar from "../productSearchbar/productSearchbar"
import Pagination from "../pagination/pagination"
import toPersianNumber from '../../helpers/actions/toPersianNumber'
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import { DeleteReport, GetProReportList } from "../../actions/APIcalls"
import { withRouter, Link } from "react-router-dom"
import ExpiredAccountWarning from "../expiredAccountWarning/expiredAccountWarning"
import GradientToast from "../gradientToast/Toast"
import DownGradeWarning from "../downGradeWarning/downGradeWarning";
import Skeleton from "./skeleton"

const ProReportList = (props) => {
    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [search, setSearch] = useState("");
    const [pageData, setPageData] = useState({ pageCount: 1, currentPage: 1, countInPage: 10 })
    const [list, setList] = useState([])
    const [showModal, setShowModal] = useState({ open: false, success: false })
    //lifecyles*************************************************
    useEffect(() => {
        if (search !== "") {
            GetList()
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])
    useEffect(() => {
        window.addEventListener('popstate', () => {
            setSearch("")
        })
        return () => window.removeEventListener('popstate', () => {
        })

    }, [])
    useEffect(() => {
        GetList()
        if (typeof props.location !== "undefined" && typeof props.location.search !== "undefined" && props.location.search !== "") {
            let url = new URLSearchParams(window.location.search);
            setSearch(url.get("search"));
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useState(() => {
        if (list.length == 0 && pageData.currentPage !== 1) {
            let page = pageData
            page.currentPage = page.currentPage - 1
            setPageData({ ...page })
        }
    }, [list])
    //get server data*********************************************
    const GetList = async () => {
        setHasSkeleton(true)
        let params = {
            query: {
                search: search,
                pageNumber: pageData.countInPage,
                page: pageData.currentPage
            }
        }
        let res = await GetProReportList(params);
        if (typeof res !== "undefined") {
            setList([...res.data.result]);
            let pageInfo = pageData;
            pageInfo.page = res.data.pageNumber;
            pageInfo.pageCount = res.data.pageCount
            setPageData({ ...pageInfo })
        }
        setHasSkeleton(false)
    }
    const deleteReport = async () => {
        console.log(showModal);
        let res = await DeleteReport({ id: showModal.id })
        console.log(res);
        if (typeof res !== "undefined", res.data.success) {
            let modal = showModal
            modal.success = true
            setShowModal({ ...modal })
            GetList()
        }
    }
    //renderer**************************************************
    const cardRenderer = (data) => {
        return <div className={style.cardWrapper}>
            <div className={style.row}>
                <h4>{data.name}</h4>
                {typeof data.hint !== "undefined" && data.hint &&
                    <div className={style.imageHolder}>
                        <div className={style.icon}>h</div>
                        <div className={style.tooltip}>
                            <div className={style.triangle}></div>
                            <div className={style.rectangle}>{data.hint}</div>
                        </div>
                    </div>
                }
            </div>
            <p>{data.description}</p>
            <div className={style.showReportButton}
                onClick={(e) =>
                    props.history.push({
                        pathname: "/report/proreportshow/" + data.englishName,
                        state: { report: { ...data } }
                    }
                    )}
            >مشاهده گزارش
            </div>
        </div>
    }
    //handlers**************************************************
    const searchHandler = (val) => {
        setSearch(val)
        props.history.push(
            '/report/proreportlist?search=' + val,
            { search: val }
        );

    }
    const pageSetter = (number) => {
        let data = pageData
        data.currentPage = number
        setPageData({ ...data })
        GetList()
    }
    const handler = async (tag, id) => {
        console.log(tag, id);
        if (tag === "delete") {
            if (typeof props.user !== "undefined" && props.user.permission.reportManagement.includes("Delete")) {
                let res = list.find(item => item._id === id)
                console.log(res);
                if (typeof res !== "undefined") {
                    console.log("delete");
                    setShowModal({ open: true, success: false, reportName: res.reportName, id: res._id })
                }
            }
        } else {
            if (typeof props.user !== "undefined" && props.user.permission.reportManagement.includes("Edit")) {
                let obj = list.find(i => i._id === id)
                if (typeof obj !== "undefined") {
                    props.history.push({ pathname: "/report/create", state: { id: id, report: { ...obj } } })
                }
            }
        }
    }
    //functions*******************************************

    const cancelDeleteModal = () => {
        setShowModal({ open: false, success: false, name: "", id: "" })
    }
    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {/* {
                    Object.keys(props.user.downGradeWarning).length !== 0 &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <DownGradeWarning data={{ ...props.user.downGradeWarning }} />
                            </>
                        </GradientToast>
                    </div>
                } */}
                <div className={style.headerWrapper}>
                    <h3>گزارشات پیشرفته</h3>
                </div>
                {/* {
                props.user.expiredAccount &&
                <ExpiredAccountWarning/>
            } */}
                {/* { console.log(Object.keys(props.user.downGradeWarning).length,"lalalalall")} */}
                {/* {
                Object.keys(props.user.downGradeWarning).length !== 0 &&
                <DownGradeWarning data={{...props.user.downGradeWarning}}/>
            } */}
                {(list.length > 0 || search) && <div className={style.searchbarWrapper}>
                    <Searchbar
                        placeholder={"نام گزارش"}
                        value={search}
                        searchValue={(value) => searchHandler(value)}
                    />
                </div>}
                {list.length > 0 ?
                    <div>

                        <div className={style.cardComponents}>
                            <div className={style.paginationRow}>
                                <div className={style.pagination}>
                                    <div className={style.Dropdown}>
                                        <Pagination currentPage={pageData.currentPage} pageCount={pageData.pageCount}
                                            setPage={pageSetter} />
                                        <TinyDropdown placeholder={10} dropdownList={["10", "25", "50", "75", "100"]}
                                            selected={selected => {
                                                let page = { ...pageData };
                                                page.countInPage = selected;
                                                setPageData({ ...page })
                                                GetList()

                                            }} />
                                        <div className={style.label}>تعداد نمایش در صفحه</div>
                                        <div className={style.verticalLine}></div>
                                        <div className={style.variantCount}>{toPersianNumber(list.length) + " گزارش "}</div>
                                    </div>
                                </div>
                            </div>
                            <div className={style.cardRow}>
                                {list.map((item, index) => {
                                    return <div className={style.container} key={index}>
                                        {cardRenderer({ ...item })}
                                    </div>
                                })}
                            </div>
                            <div className={style.paginationTwo}>
                                <Pagination currentPage={pageData.currentPage} pageCount={pageData.pageCount}
                                    setPage={pageSetter} />
                            </div>

                        </div>


                    </div> :
                    (search ? <div className={style.noResult}>
                        <div className={style.noResultInSearchIcon}></div>
                        <p className={style.boldText}>!نتیجه‌ای یافت نشد</p>
                        <p>.نتیجه‌ای مطابق با جستجوی شما یافت نشد. لطفا عبارت دیگری را امتحان کنید</p>
                    </div>
                        : <div className={style.emptyListBox}>
                            <div className={style.noResultInSearchIcon}></div>
                            <p className={style.text}>.کاربر عزیز، در حال حاضر شما هیچ گزارشی در ربات موبیشا ندارید</p>
                        </div>)}

            </div>
        )
    }

}

export default withRouter(ProReportList);
